/* src/app/components/controls/content-controls/sem-activity-trail/sem-activity-trail.component.css */
:host {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  font-family:
    Inter,
    "Segoe UI",
    sans-serif;
}
.activity-trail-panel {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}
.activity-trail-header {
  display: flex;
  align-items: center;
  padding-bottom: 18px;
  margin-bottom: 6px;
  border-bottom: 1px solid #e2e8f0;
  flex: 0 0 auto;
}
.activity-trail-header-label {
  font-weight: 700;
  font-size: 15px;
  color: #0f172a;
  flex: 1 1 auto;
}
.activity-trail-placeholder {
  color: #94a3b8;
  font-size: 12.5px;
  padding: 16px 0;
}
.activity-trail-list {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}
.activity-trail-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-top: 4px;
  padding: 10px 0;
  border: none;
  border-top: 1px solid #f1f5f9;
  background: none;
  cursor: pointer;
  font-weight: 500;
  font-size: 12px;
  color: #3b82f6;
}
.activity-trail-toggle:hover {
  color: #2563eb;
}
.activity-trail-toggle:focus-visible {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
  border-radius: 4px;
}
.activity-trail-toggle .material-symbols-outlined {
  font-size: 16px;
}
.activity-trail-item {
  display: flex;
  gap: 12px;
  padding: 14px 0;
  opacity: 0;
  transform: translateY(3px);
  animation: activity-trail-in 0.28s ease-out forwards;
}
@keyframes activity-trail-in {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (prefers-reduced-motion: reduce) {
  .activity-trail-item {
    animation: none;
    opacity: 1;
    transform: none;
  }
}
.activity-trail-icon {
  flex: 0 0 auto;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f5f9;
  color: #64748b;
}
.activity-trail-icon .material-symbols-outlined {
  font-size: 16px;
}
.activity-trail-icon--StatusChanged {
  background: rgba(99, 102, 241, 0.12);
  color: #6366f1;
}
.activity-trail-icon--LocationAdded {
  background: rgba(139, 190, 35, 0.14);
  color: #6f9c1c;
}
.activity-trail-icon--LocationRemoved {
  background: rgba(227, 76, 76, 0.12);
  color: #e34c4c;
}
.activity-trail-icon--ProcedureCreated,
.activity-trail-icon--ProcedureFinalized {
  background: rgba(247, 180, 34, 0.16);
  color: #c9860a;
}
.activity-trail-icon--ProcedureRemoved {
  background: rgba(227, 76, 76, 0.12);
  color: #e34c4c;
}
.activity-trail-content {
  flex: 1 1 auto;
  min-width: 0;
  padding-top: 2px;
}
.activity-trail-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 8px;
}
.activity-trail-label {
  font-weight: 700;
  font-size: 13.5px;
  color: #1e293b;
  line-height: 1.4;
}
.activity-trail-time {
  flex: 0 0 auto;
  font-size: 11.5px;
  color: #94a3b8;
  font-variant-numeric: tabular-nums;
}
.activity-trail-values {
  font-size: 12.5px;
  color: #64748b;
  margin-top: 3px;
  overflow-wrap: anywhere;
}
.activity-trail-values .new {
  font-weight: 700;
  color: #1e293b;
}
.activity-trail-meta {
  font-size: 11.5px;
  color: #94a3b8;
  margin-top: 4px;
}
.activity-trail-group-summary {
  display: block;
  width: 100%;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  text-align: left;
  font: inherit;
  color: inherit;
}
.activity-trail-group-meta-inline {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 4px;
}
.activity-trail-group-chevron {
  font-size: 17px !important;
  color: #94a3b8;
}
.activity-trail-group-summary:hover .activity-trail-label {
  color: #3b82f6;
}
.activity-trail-group-summary:focus-visible {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
  border-radius: 4px;
}
.activity-trail-group-details {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 12px;
  padding-left: 14px;
  border-left: 2px solid #f1f5f9;
}
.activity-trail-group-entry .activity-trail-content--nested {
  padding-top: 0;
}
.activity-trail-group-entry .activity-trail-content--nested .activity-trail-label {
  font-size: 12.5px;
}
/*# sourceMappingURL=sem-activity-trail.component.css.map */
